export class CopyDeleteController {
  constructor($scope) {
    this.$scope = $scope;
    $scope.addRow = this.addRow.bind(this);
    $scope.deleteRow = this.deleteRow.bind(this);
  }

  addRow() {
    const repeaterScope = this.findRepeaterScope(this.$scope);
    if (!repeaterScope) {
      return;
    }

    repeaterScope.copy(this.$scope.model);
  }

  deleteRow() {
    const repeaterScope = this.findRepeaterScope(this.$scope);
    if (!repeaterScope) {
      return;
    }

    repeaterScope.remove(this.$scope.model);
  }

  findRepeaterScope($scope) {
    if (!$scope || $scope.remove) {
      return $scope;
    }
    return this.findRepeaterScope($scope.$parent);
  }
}
CopyDeleteController.$inject = ["$scope"];
